<template>
  <b-col sm="12" :lg="lgSize" :offset-lg="lgOffset">
    <DateModal
      modalID="proofOfDeliveryModal"
      :fetchData="fetchData"
      :dateFrom="dateFrom"
      :dateTo="dateTo"
      @date-picker-modal-emit="onDatePickerModalEmit"
    ></DateModal>

    <div class="animated fadeIn">
      <b-card class="backClass" header="Received">
        <div
          slot="header"
          style="display:flex; justify-content: space-between;"
        >
          <HeaderTitle
            title="Proof Of Delivery"
            :dateFrom="
              from(dateFrom)
                ? $formatUSDate(from(dateFrom))
                : $formatUSDate(dateFrom)
            "
            :dateTo="
              to(dateTo) ? $formatUSDate(to(dateTo)) : $formatUSDate(dateTo)
            "
          ></HeaderTitle>
          <HeaderControl
            :showDateIcon="true"
            @emit-date="modalDateEvent"
          ></HeaderControl>
        </div>
        <div class>
          <LoadingCard v-if="loadingData"></LoadingCard>
          <div v-else>
            <b-row>
              <b-col lg="4" class="my-1">
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Type to Search"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''"
                      >Clear</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <br />
            <b-table :filter="filter" :fields="fields" size="lg" :items="items">
              <template v-slot:cell(user)="{ value }">
                <img :src="value" width="40px" style="border-radius: 100px;" />
              </template>
              <template v-slot:cell(image)="row">
                <b-button
                  size="sm"
                  @click="info(row.item, row.index, $event.target)"
                  class="mr-1"
                >
                  <i class="fa fa-photo" aria-hidden="true"></i>
                </b-button>
              </template>
            </b-table>
          </div>
        </div>
        <b-modal
          :id="infoModal.id"
          :title="infoModal.title"
          ok-only
          @hide="resetInfoModal"
        >
          <img :src="infoModal.content" width="100%" />
        </b-modal>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../../router";
import Datepicker from "vuejs-datepicker";
import cTable from "../../views/base/tables/Table.vue";
import DateModal from "../shared/DateModal.vue";
import HeaderTitle from "../shared/HeaderTitle.vue";
import HeaderControl from "../shared/HeaderControl.vue";
import LoadingCard from "../shared/LoadingCard.vue";
import { from, isUserLoggedIn, to } from "../../utils/Utils";

export default {
  name: "ProofOfDeliveryCityDashboard",
  components: {
    router,
    cTable,
    highcharts: Chart,
    Datepicker,
    DateModal,
    HeaderTitle,
    HeaderControl,
    LoadingCard
  },
  props: ["lgSize", "lgOffset", "locParam", "idCity", "nameCity"],
  data: function() {
    return {
      from: from,
      to: to,
      filter: null,
      fullscreen: false,
      loadingData: false,
      showAll: false,
      modalDate: false,
      dateFrom: "",
      dateTo: "",
      city: "",
      locationName: "",
      productGroup: "",
      locationsIds: "",
      title: "",
      items: [],
      fields: [
        { key: "user", label: "Driver" },
        {
          key: "shipDate",
          label: "Ship Date",
          formatter: (value, key, item) => {
            return this.$formatUSDate(item.shipDate);
          }
        },
        {
          key: "deliveryDate",
          label: "Delivery Date",
          formatter: (value, key, item) => {
            return this.$formatUSDate(item.shipDate);
          }
        },
        { key: "ranum", label: "RMA" },
        { key: "InvoiceNo", label: "#InvoiceNo" },
        {
          key: "InvoiceDate",
          label: "#Invoice Date",
          formatter: (value, key, item) => {
            return this.$formatUSDate(item.shipDate);
          }
        },
        { key: "image", label: "Image" }
      ],
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      }
    };
  },
  methods: {
    onDatePickerModalEmit(changedDateFrom, changedDateTo) {
      this.dateFrom = changedDateFrom;
      this.dateTo = changedDateTo;
    },
    modalDateEvent() {
      this.exitFullscreen();
      this.$bvModal.show("proofOfDeliveryModal");
    },
    exitFullscreen() {
      if (!this.fullscreen) {
        return;
      } else {
        this.toggleFullScreen();
      }
    },
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".backClass"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    forceDownload(url, fileName) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(this.response);
        var tag = document.createElement("a");
        tag.href = imageUrl;
        tag.download = fileName;
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
      };
      xhr.send();
    },
    info(item, index, button) {
      this.infoModal.title = `RMA: ${item.ranum}`;
      this.infoModal.content =
        "https://fibernode.com/storage/proof-of-delivery/" + item.image;
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    fetchData() {
      this.loadingData = true;
      let params = {};
      params = {
        client_location: this.idCity,
        date_from: from(this.dateFrom),
        date_to: to(this.dateTo)
      };
      this.$http
        .get("api/tables/delivery_info.php", {
          params
        })
        .then(
          res => {
            this.loadingData = false;
            this.title = "Total records: " + res.data.count;
            this.items = res.data.records;
          },
          err => {
            this.loadingData = false;
            console.log(err);
          }
        );
    }
  },
  mounted() {
    isUserLoggedIn(router);
    const date = new Date();
    date.setDate(date.getDate() - 30);
    this.dateFrom = date.toISOString().split("T")[0];
    this.dateTo = new Date().toJSON().slice(0, 10);

    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
</style>
